import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ApplicationApi } from "../../../../../../../../../../../services/Api/Organization/types";

interface Props {
	show: boolean;
	onHide: () => void;
	apps: ApplicationApi[];
	fetchProviders: (appId: number) => Promise<void>;
	setSelectedGoOrder: React.Dispatch<React.SetStateAction<ApplicationApi | undefined>>;
}

const MenuExternalPortalGoOrderModal = ({ apps, onHide, show, fetchProviders, setSelectedGoOrder }: Props) => {
	const { t } = useTranslation();

	const handleSelect = async (app: ApplicationApi) => {
		setSelectedGoOrder(app);
		await fetchProviders(app.id);
		onHide();
	};

	return (
		<Modal show={show}>
			<Modal.Header>
				<Modal.Title>{t("modules.external_portal.field.choose_app.title")}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="d-flex flex-column gap-2">
					{apps.map((app) => (
						<div className="d-flex align-items-center justify-content-between gap-2" key={app.id}>
							<p className="mb-0">{app.name}</p>
							<Button onClick={() => handleSelect(app)}>{t("lib:common.action.select")}</Button>
						</div>
					))}
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default MenuExternalPortalGoOrderModal;
